import SmoothScroll from 'smooth-scroll';
import '@fancyapps/fancybox';
import {fitGoogleMapMarkers} from "./modules/map";
import {animateInViewport} from "./transition";

var navTimeouts = [];
var $html = $( 'html' );

var smoothScroll = new SmoothScroll( 'a[href*="#"]', {
	topOnEmptyHash: false,
	updateURL: false,
	speed: 1000,
	speedAsDuration: true,
	offset: function( anchor, toggle ) {
		return 0;
	},
} );

$( function() {
	sanitizeTargetBlank();

	$( '.fancybox' ).fancybox( {} );

	$( '.hamburger-toggle' ).on( 'click', function( event ) {
		if ( $html.hasClass( 'active-main-menu' ) ) {
			closeHamburger();
		} else {
			openHamburger();
		}
	} );

	$( '.hamburger-close' ).on( 'click', function( event ) {
		closeHamburger();
	} );

	$( '.toggle' ).on( 'click', function( event ) {
		let $this = $( this );

		$this.find( '.open, .close' ).toggleClass( 'opacity-0 opacity-100 rotate-90' );

		$this.parents( '.toggle-container' ).find( '.toggle-content' ).toggle( 200 );
	} );

	$( '.sub-menu-toggle' ).parent().each( function() {
		const $this = $( this );
		const subMenuToggleParent = this;
		$this.find( '.sub-menu a' ).click( function() {
			closeHamburger();
			toggleSubmenu.call( $( subMenuToggleParent ).find( '.sub-menu-toggle' )[ 0 ] );
		} );
	} );

	$( '.filter-group .filter-group-toggle' ).on( 'click', function() {
		var $this = $( this );

		$( '.filter-group' ).find( '.filter-items-container' ).stop().slideUp( 'fast' );
		// $( '.filter-group' ).find( '.filter-group-arrow' ).removeClass( '-rotate-90' ).addClass( 'rotate-90' );

		$this.parents( '.filter-group' )
			.find( '.filter-items-container' ).stop().slideToggle( 'fast' );
		// $this.parents( '.filter-group' )
		// 	.find( '.filter-group-arrow' ).removeClass( 'rotate-90' ).addClass( '-rotate-90' );
	} );

	$( '.before-after-toggle' ).on( 'click', function( event ) {
		var $this = $( this );
		var $target = $this.parents( '.before-after' ).find( '.after' );

		$target.stop().toggle( 300, function() {
		} );

		$this.toggleClass( 'active' ).find( '.custom-toggle' ).toggleClass( 'active' );

		$this.find( '.open-text, .close-text' ).toggleClass( 'hidden' );

		animateInViewport();
	} );

	$( '.sub-menu-toggle' ).on( 'click', toggleSubmenu );

	function toggleSubmenu() {
		var $this = $( this );
		$this.parent().find( '.sub-menu' ).stop().toggle( 300, function() {
		} );

		$this.toggleClass( 'active' );
	}

	updateFilterContainerVisibility();
	$( '.filter-toggle' ).on( 'click', function( event ) {
		toggleFilter();
	} );

	$( '.filter-close' ).on( 'click', function( event ) {
		toggleFilter( false );
	} );

	$( '.guide-filter-toggle' ).on( 'click', function( event ) {
		$( this ).parent().find( '#menu-overlay-menu' ).stop().toggle( 300 );
	} );

	$( '.guide-filter' ).on( 'click', function( event ) {
		$( this ).parents( '.guide-filter-container' ).find( '#menu-overlay-menu' ).stop().slideUp( 300 );
		$( '.guide-filter-selection' ).html( $( this ).html() );
	} );
} );

(function( $, sr ) {
	// debouncing function from John Hann
	// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
	var debounce = function( func, threshold, execAsap ) {
		var timeout;

		return function debounced() {
			var obj = this,
				args = arguments;

			function delayed() {
				if ( !execAsap ) func.apply( obj, args );
				timeout = null;
			};

			if ( timeout ) clearTimeout( timeout ); else if ( execAsap ) func.apply( obj, args );

			timeout = setTimeout( delayed, threshold || 100 );
		};
	};
	// smartresize
	jQuery.fn[ sr ] = function( fn ) {
		return fn ? this.bind( 'resize', debounce( fn ) ) : this.trigger( sr );
	};

})( jQuery, 'smartresize' );

$( window ).smartresize( function() {
	updateFilterContainerVisibility();
} );

export function toggleFilter( show ) {
	const $filter = $( '#filter' );
	const $filterBackground = $( '.filter-background' );

	if ( show !== false && show !== true ) {
		show = !$filter.hasClass( 'active' );
	}

	$filter.toggleClass( 'active', show );
	$( '.filter-toggle' ).toggleClass( 'active', show ).find( '.icon' ).toggleClass( 'rotate-45', show );
	$filterBackground.toggleClass( '!opacity-100', show ).toggleClass( 'pointer-events-none', !show );
	updateFilterContainerVisibility();
}

export function updateFilterContainerVisibility() {
	const $filterContainer = $( '#filter-container' );
	const $filter = $( '#filter' );
	const filterHeight = ($filter.hasClass( 'active' )) ? 0 : 'calc(100% - ' + $( '.menu-overflow-menu-container', $filterContainer ).outerHeight() + 'px)';
	$filterContainer.css( {
		'transform': 'translateY(' + filterHeight + ')',
	} );
}

var newScrollTop,
	currentScrollTop = 0,
	scrollTarget = $( 'html' );

$( window ).scroll( function() {
	var scrollTop = $( window ).scrollTop();

	if ( scrollTop > 20 ) {
		scrollTarget.addClass( 'scrolling' );

		currentScrollTop = scrollTop;

		if ( newScrollTop < currentScrollTop ) {
			scrollTarget.addClass( 'scroll-down' ).removeClass( 'scroll-up' );
		} else if ( newScrollTop > currentScrollTop ) {
			scrollTarget.removeClass( 'scroll-down' ).addClass( 'scroll-up' );
		}
		newScrollTop = currentScrollTop;
	} else {
		scrollTarget.removeClass( 'scroll-down' ).removeClass( 'scrolling' ).removeClass( 'scroll-up' );
	}
} );

function openHamburger() {
	$html.addClass( 'active-main-menu' );

	$( '.hamburger-toggle' ).addClass( 'active' ).addClass( '!bg-transparent' ).find( '.open, .close' ).toggleClass( 'opacity-0 opacity-100 rotate-90' );

	$( '.site-navigation-secondary' ).addClass( 'active' );

	$( '.site-navigation-menu-item' ).each( function( index ) {
		let $this = $( this );

		navTimeouts.push( setTimeout( function() {
			$this.addClass( 'active' );
		}, 250 + index * 50 ) );
	} );
}

export function closeHamburger() {
	$( '.hamburger-toggle' ).removeClass( 'active' ).removeClass( '!bg-transparent' ).find( '.open, .close' ).toggleClass( 'opacity-0 opacity-100 rotate-90' );

	$( '.site-navigation-secondary' ).removeClass( 'active' );

	$( '.site-navigation-menu-item' ).removeClass( 'active' );

	navTimeouts.forEach( function( timeout ) {
		clearTimeout( timeout );
	} );

	navTimeouts = [];

	$html.removeClass( 'active-main-menu' );
}

/* 3/24/2017 Sanitize_Target_Blank.htm https://gist.github.com/JamoCA/80f65eb07f054b1326221bd4f15868d6 */
function sanitizeTargetBlank() {
	$( 'a[rel~=external]' ).prop( 'target', '_blank' );
	$( 'a[target="_blank"]' ).each( function() {
		var a = $( this );
		if ( location.hostname !== this.hostname ) {
			var originalRel = (this.rel === undefined) ? '' : this.rel.toLowerCase();
			var newRel = originalRel.split( " " );
			if ( originalRel.indexOf( 'noopener' ) === -1 ) {
				newRel.push( 'noopener' );
			}
			if ( originalRel.indexOf( 'noreferrer' ) === -1 ) {
				newRel.push( 'noreferrer' );
			}
			if ( originalRel.indexOf( 'nofollow' ) === -1 ) {
				newRel.push( 'nofollow' );
			}
			a.attr( 'rel', newRel.join( " " ).trim() );
		}
	} );
	console.log( 'External AHREF links have been sanitized.', new Date );
}

function viewRel() {
	var linkLog = [];
	console.log( 'Identifying all AHREF links with target="_blank"...' );
	$( 'a[target="_blank"]' ).each( function( i ) {
		var a = $( this );
		var r = a.attr( 'rel' );
		if ( r !== undefined ) {
			r = r.split( " " );
		}
		var entry = {
			'index': i,
			'linkText': a.text(),
			'href': a.attr( 'href' ),
			'target': a.attr( 'target' ),
			'rel': r,
		};
		linkLog.push( entry );
	} );
	console.table( linkLog );
}

$( function() {
	$( '.boolean-toggle' ).each( function() {
		const $toggles = $( '*[data-toggle-target]', $( this ) );
		$toggles.click( function() {
			const clickedTargetId = $( this ).attr( 'data-toggle-target' );
			$toggles.each( function() {
				const $this = $( this );
				$this.toggleClass( 'hidden', !$this.hasClass( 'hidden' ) );

				const targetId = $this.attr( 'data-toggle-target' );
				const $target = $( '#' + $this.attr( 'data-toggle-target' ) );
				$target.toggleClass( 'hidden', targetId === clickedTargetId );
			} );
			window.msnry.masonry();
			fitGoogleMapMarkers();
		} );
	} );
} );

$( function() {
	const $overlayMenuParent = $( '#menu-overlay-menu' ).parent();
	const $overlay = $( '<div class="overlay-menu-overlay block invisible-link px-3 pt-1.5 pb-2 paragraph-4 rounded-[12px]" style="z-index: -1"></div>' );
	$overlayMenuParent.append( $overlay );
	$overlayMenuParent.find( '.menu-item' ).each( function( i, menuItem ) {
		const $this = $( this );
		$this
			.on( 'mouseover', function() {
				let menuItemBoundingClientRect = menuItem.getBoundingClientRect();
				$overlay.addClass( 'active' );
				$overlay.css( {
					left: menuItem.offsetLeft + 'px',
					top: menuItem.offsetTop + 'px',
					height: menuItemBoundingClientRect.height + 'px',
					width: menuItemBoundingClientRect.width + 'px',
				} );
			} )
			.on( 'mouseout', function() {
				$overlay.removeClass( 'active' );
			} );
	} );
} );

$( function createAnimatedPaginationOverlay() {
		$( '.animated-pagination' ).each( function() {
			const $overlayMenuParent = $( this );
			const $overlay = $( '<div class="animated-pagination-overlay absolute block invisible-link px-3 pt-1.5 pb-2 paragraph-4 rounded-[12px]" style="z-index: -1"></div>' );
			$overlayMenuParent.append( $overlay );
			$overlayMenuParent.find( '.animated-pagination-button' ).each( function( i, menuItem ) {
				const $this = $( this );
				$this
					.on( 'mouseover', function() {
						let menuItemBoundingClientRect = menuItem.getBoundingClientRect();
						$overlay.addClass( 'active' );
						$overlay.css( {
							left: menuItem.offsetLeft + 'px',
							top: menuItem.offsetTop + 'px',
							height: menuItemBoundingClientRect.height + 'px',
							width: menuItemBoundingClientRect.width + 'px',
						} );
					} )
					.on( 'mouseout', function() {
						$overlay.removeClass( 'active' );
					} );
			} );
		} );
	},
);
